'use client'

import { usePathname } from 'next/navigation'
import type { ReactNode } from 'react'
import { useEffect, useRef } from 'react'

export default function SmoothScroll({ children }: { children: ReactNode }) {
  const pathname = usePathname()
  const skipNextScrollRef = useRef(false)

  useEffect(() => {
    if (typeof window === 'undefined') return

    const onPopState = () => {
      // Keep native scroll restoration on browser Back/Forward.
      skipNextScrollRef.current = true
    }

    window.addEventListener('popstate', onPopState)
    return () => window.removeEventListener('popstate', onPopState)
  }, [])

  useEffect(() => {
    if (typeof window === 'undefined') return
    if (skipNextScrollRef.current) {
      skipNextScrollRef.current = false
      return
    }
    if (window.location.hash) return

    const rafId = window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    })

    return () => window.cancelAnimationFrame(rafId)
  }, [pathname])

  return <>{children}</>
}
